import axios from "axios";
import { logout } from "modules/auth/actions";
import { isAuthError } from "utils/utils";
import {store} from '../app/storeConfig'
import { notAuthedMessage } from "./constants";

const $authHost = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
})

const authInterceptor = config => {
    const token = localStorage.getItem("token")
    if (token) config.headers.authorization = `Bearer ${token}`

    return config
}

const errLogout = () => {
    localStorage.removeItem("token")
    store.dispatch(logout())
}

const onSuccess = (data) => {
    if (data.errors?.length) {
        if (isAuthError(errors)) {
            errLogout()
        }

        return Promise.reject()
    }
    
    return Promise.resolve(data)
}

const onError = (error) => {
    if (error.response.status === 401) {
        errLogout()
    }
     
    return Promise.reject(error)
}

$authHost.interceptors.request.use(authInterceptor)

$authHost.interceptors.response.use(onSuccess, onError)

export {
    $authHost
}
